import React from 'react';
import classNames from 'classnames';
import makeStyles from '@mui/styles/makeStyles';
import { ClassNameMap } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap'
    },
    width: '100%'
  },
  label: {
    flexBasis: theme.spacing(11),
    flexGrow: 0,
    flexShrink: 0,
    color: theme.palette.text.secondary,
    margin: theme.spacing(0, 2, 0, 0),
    fontSize: theme.typography.caption.fontSize,
    fontFamily: theme.typography.fontFamily,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      flexBasis: '100%',
      margin: 0
    }
  }
}));

export type FacetDetailFieldProps = {
  children: React.ReactNode;
  label: React.ReactNode;
  classes?: ClassNameMap;
  className?: string;
};

export const FacetDetailField: React.FC<FacetDetailFieldProps> = ({
  classes: overrideClasses,
  className,
  label,
  children
}: FacetDetailFieldProps) => {
  const classes = useStyles({ classes: overrideClasses });

  return (
    <div className={classNames(classes?.root, className)}>
      <span className={classes?.label}>{label}</span>
      {children}
    </div>
  );
};

export default FacetDetailField;
